import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./hero.scss";
// import groveDome from "../../assets/images/grove-dome.png";
import { useDispatch } from "react-redux";
import { changeTab } from "../../__redux/slices/AppSlice";
import berryIcon from "../../assets/images/berryIcon.png";
import droveDrone from "../../assets/images/mg-drone-img.JPG";
import Button from "../../components/Button/Button";

export function MGLogo({ logoPosition, handleClick = () => {} }) {
  //can be front or middle or stacked
  return (
    <div className="MGLogo" onClick={handleClick}>
      {logoPosition !== "stacked" && (
        <>
          {logoPosition === "front" ? (
            <>
              <img className="__logo" alt="maple grove logo" src={berryIcon} />
              <h2>Maple Grove</h2>
            </>
          ) : (
            <>
              <h2>Maple Grove</h2>
              <img className="__logo" alt="maple grove logo" src={berryIcon} />
            </>
          )}

          <h2>
            <span>Permaculture</span>
          </h2>
        </>
      )}
      {logoPosition === "stacked" && (
        <div className="stacked-logo">
          <img className="__logo" alt="maple grove logo" src={berryIcon} />
          <div>
            <h2>Maple Grove</h2>
            <h2>
              <span>Permaculture</span>
            </h2>
          </div>
        </div>
      )}
    </div>
  );
}

function Hero() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const heroImgRef = useRef(null);

  // Always land at the top of the home page — on initial load, refresh, or
  // navigating back here. Disabling the browser's scroll restoration stops it
  // from re-applying a previous scroll position on refresh/back.
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
  }, []);

  // Subtle scroll parallax: the background drifts slower than the page.
  useEffect(() => {
    const el = heroImgRef.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let frame = null;
    const update = () => {
      const offset = window.scrollY * 0.1;
      el.style.transform = `translate3d(0, ${offset}px, 0)`;
      frame = null;
    };
    const onScroll = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, []);

  const handleLinkClick = (linkName) => {
    dispatch(changeTab(linkName));
    switch (linkName) {
      case "Store":
        navigate("/store");
        break;
      case "Events":
        navigate("/events");
        break;
      case "About Us":
        navigate("/about");
        break;
      case "Services":
        navigate("/services");
        break;
      default:
        navigate("/store");
    }
  };
  return (
    <div className="Hero">
      <img
        className="__hero"
        ref={heroImgRef}
        src={droveDrone}
        alt="hero"
      ></img>
      <div className="hero-top">
        <div className="hero-content-container">
          <MGLogo logoPosition="stacked" />
          <div className="hero-text-container">
            <p className="intro-paragraph">
              Welcome! Our tree and perennial sales for spring pick-up are now
              in full swing. With limited inventory, we encourage you to visit
              our store soon to prepare for the spring 2026 season. <br />
              <br /> Our Earth & Aircrete Dome Home is now available for booking
              along with several other unique retreat spaces.
            </p>
          </div>
          <div className="cta-buttons">
            <Button onClick={() => handleLinkClick("Store")}>
              Check our Shop
            </Button>
            <Button
              variant="secondary"
              onClick={() => handleLinkClick("Services")}
            >
              Book a Retreat
            </Button>
          </div>
        </div>
      </div>
      {/* <div className="hero-bot">
        <div className="hero-buttons-container">
          <div className="hero-link-row">
            <div
              className="link-button"
              onClick={() => handleLinkClick("Store")}
            >
              <img
                className="link-button-img"
                src={storeButton}
                alt="Store Button"
              />
              <div className="text-overlay">Store</div>
            </div>
            <div
              className="link-button"
              onClick={() => handleLinkClick("Services")}
            >
              <img
                className="link-button-img"
                src={servicesButton}
                alt="Services Button"
              />
              <div className="text-overlay">Stay With Us</div>
            </div>

            <div
              className="link-button"
              onClick={() => handleLinkClick("About Us")}
            >
              <img
                className="link-button-img"
                src={aboutButton}
                alt="About Button"
              />
              <div className="text-overlay">About Us</div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Hero;
